import { render, staticRenderFns } from "./TemplateSearchNodataMergeSearch.vue?vue&type=template&id=fa1a91d6&scoped=true&"
import script from "./TemplateSearchNodataMergeSearch.vue?vue&type=script&lang=js&"
export * from "./TemplateSearchNodataMergeSearch.vue?vue&type=script&lang=js&"
import style0 from "./TemplateSearchNodataMergeSearch.vue?vue&type=style&index=0&id=fa1a91d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa1a91d6",
  null
  
)

export default component.exports